'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _utils = require('./utils');

/**
 * return the unique integer hash value for the object
 *
 * @param {*} object
 * @returns {number}
 */
var hashIt = function hashIt(object) {
  var stringifiedValue = (0, _utils.getStringifiedValue)(object);
  return (0, _utils.getIntegerHashValue)(stringifiedValue);
};
var UNDEFINED_HASH = hashIt(undefined);
var NULL_HASH = hashIt(null);
var EMPTY_ARRAY_HASH = hashIt([]);
var EMPTY_MAP_HASH = hashIt(new Map());
var EMPTY_NUMBER_HASH = hashIt(0);
var EMPTY_OBJECT_HASH = hashIt({});
var EMPTY_SET_HASH = hashIt(new Set());
var EMPTY_STRING_HASH = hashIt('');

/**
 * determine if all objects passed are equal in value to one another
 *
 * @param {array<*>} objects
 * @returns {boolean}
 */
hashIt.isEqual = function () {
  var length = arguments.length;
  if (length === 1) {
    throw new Error('isEqual requires at least two objects to be passed for comparison.');
  }
  var index = 0;
  while (++index < length) {
    if (hashIt(arguments.length <= index - 1 ? undefined : arguments[index - 1]) !== hashIt(arguments.length <= index ? undefined : arguments[index])) {
      return false;
    }
  }
  return true;
};

/**
 * determine if object is empty, meaning it is an array / object / map / set with values populated,
 * or is a string with no length, or is undefined or null
 *
 * @param {*} object
 * @returns {boolean}
 */
hashIt.isEmpty = function (object) {
  var objectHash = hashIt(object);
  return objectHash === UNDEFINED_HASH || objectHash === NULL_HASH || objectHash === EMPTY_ARRAY_HASH || objectHash === EMPTY_MAP_HASH || objectHash === EMPTY_NUMBER_HASH || objectHash === EMPTY_OBJECT_HASH || objectHash === EMPTY_SET_HASH || objectHash === EMPTY_STRING_HASH;
};

/**
 * determine if object is null
 *
 * @param {*} object
 * @returns {boolean}
 */
hashIt.isNull = function (object) {
  return hashIt(object) === NULL_HASH;
};

/**
 * determine if object is undefined
 *
 * @param {*} object
 * @returns {boolean}
 */
hashIt.isUndefined = function (object) {
  return hashIt(object) === UNDEFINED_HASH;
};

/**
 * return the unique integer hash value for the object
 *
 * @param {*} object
 * @returns {number}
 */
hashIt.withRecursion = function (object) {
  var stringifiedValue = (0, _utils.getStringifiedValueWithRecursion)(object);
  return (0, _utils.getIntegerHashValue)(stringifiedValue);
};
exports.default = hashIt;
module.exports = exports['default'];